var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};
import { Button, Link } from "@whitespace/components";
import { treeMenuContext } from "@whitespace/components/src/contexts";
import clsx from "clsx";
import React, { useCallback, useContext } from "react";
import { filterAttributes } from "../utils";
import TreeMenuList from "./TreeMenuList";
export default function TreeMenuItem(_a) {
  var _b = _a,
    {
      item,
      path
    } = _b,
    restProps = __objRest(_b, ["item", "path"]);
  let attributes = filterAttributes(restProps);
  const {
    id,
    children = [],
    url,
    label
  } = item;
  const {
    isCurrentItem,
    isFocusedPath,
    isItemExpanded,
    registerItemElement,
    setFocusedPath,
    styles,
    toggleExpandedItem
  } = useContext(treeMenuContext);
  const refCallback = useCallback(element => {
    registerItemElement(path, element);
  }, []);
  const handleLinkClick = useCallback(() => {
    setFocusedPath(path);
  }, []);
  let isExpanded = isItemExpanded(path);
  let isCurrent = isCurrentItem(item);
  let linkProps = {
    innerRef: refCallback,
    to: url,
    key: "link",
    tabIndex: isFocusedPath(path) ? 0 : -1,
    className: clsx(styles.link),
    onClick: handleLinkClick
  };
  if (isExpanded) {
    linkProps["aria-expanded"] = isExpanded;
  }
  return /* @__PURE__ */React.createElement("li", __spreadProps(__spreadValues({}, attributes), {
    className: clsx(styles.item, isCurrent && styles.current)
  }), /* @__PURE__ */React.createElement("div", {
    className: styles.row
  }, /* @__PURE__ */React.createElement(Link, __spreadValues({}, linkProps), " ", label), !!children.length && /* @__PURE__ */React.createElement(Button, {
    onClick: () => {
      toggleExpandedItem(path);
    },
    onFocus: () => {
      setFocusedPath(path);
    },
    key: "toggle",
    as: "button",
    styles: {},
    className: clsx(styles.toggle, isExpanded ? styles.expanded : styles.collapsed),
    tabIndex: -1,
    "aria-expanded": isExpanded,
    "aria-controls": id
  })), !!children.length && /* @__PURE__ */React.createElement(TreeMenuList, {
    id,
    expanded: isExpanded,
    items: children,
    parentPath: path
  }));
}